import React from 'react'
import {
    Divider,
    Row,
    Form,
    Select,
    Button,
    Input,
    Switch,
    notification,
    Col,
    Typography,
    Spin,
    Tabs,
    Upload,
    message,
    Radio,
} from 'antd'
import { Link } from 'react-router-dom';
import API from '../../services/API'
import Segment from '../../components/Segment'
import Search from '../../components/Search'
import { onKeyPressNumbers } from '../../services/Utils'

const { Option } = Select
const { TabPane } = Tabs
const acceptedFileTypes = ['cer', 'pem']

const INIT = {
    name: '',
    code: '',
    main_warehouse_id: null,
    rfc: '',
    business_name: '',
    manager_id: '',
    address: '',
    zipcode: '',
    phone: '',
    suburb_id: '',
    active: true,
    created_at: '',
    updated_at: '',
    visible: false,
    logo_url: null,
    is_resico: false, // Tab facturacion
    billing_tax_regime: '',
    cash_withdrawal_limit: 0,
    billing_passphrase: '',
    billing_passphrase_test: '',
    sandbox: false,
    accountable_type: '',
    social_reason: '',
}

const SubsidiariesEditContainer = ({ match }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [currentSearchManager, setCurrentSearchManager] = React.useState('')
    const [suburbs, setSuburbs] = React.useState([])
    const [currentSearchTaxRegimes, setCurrentSearchTaxRegimes] = React.useState('')
    const [fileList, setFileList] = React.useState({})
    const [customBilling, setCustomBilling] = React.useState(false)
    const billing_permission = 1

    const isSaveDisabled = () => {
        let disabled =
            !data.name ||
            !data.code ||
            !data.business_name ||
            !data.manager_id ||
            !data.phone ||
            !data.rfc ||
            !data.zipcode ||
            !data.address ||
            !data.suburb_id

        if (customBilling) {
            disabled = disabled || !fileList.billing_cer_path || !fileList.billing_stamp_path || !data.billing_tax_regime || !data.billing_passphrase;
        }

        return disabled;
    }

    const getData = () => {
        setloading(true)
        API.get(`/api/subsidiaries/${match.params.id}`)
            .then(response => {
                setloading(false)
                const propertiesToUpdate = {
                    billing_cer_path: { uid: '1', name: 'billing_cer_path', status: 'done' },
                    billing_stamp_path: { uid: '2', name: 'billing_stamp_path', status: 'done' },
                    billing_cer_path_test: { uid: '3', name: 'billing_cer_path_test', status: 'done' },
                    billing_stamp_path_test: { uid: '4', name: 'billing_stamp_path_test', status: 'done' },
                }

                const { billing_passphrase, billing_cer_path, billing_stamp_path } = response.data;

                if (billing_passphrase && billing_cer_path && billing_stamp_path) {
                    setCustomBilling(true);
                }

                const updatedFileList = {};
                Object.entries(propertiesToUpdate).forEach(([property, config]) => {
                    if (response.data[property]) {
                        updatedFileList[property] = [{ ...config, url: response.data[property] }]
                    }
                })
                setFileList(updatedFileList);
                setData(response.data)
                if (response.data.billing_tax_regime) {
                    setCurrentSearchTaxRegimes(response.data.billing_tax_regime)
                }
                if (response.data.tax_regime) {
                    setCurrentSearchTaxRegimes(response.data.tax_regime)
                }
                if (response.data.manager) {
                    setCurrentSearchManager(response.data.manager.name)
                }
                if (response.data.zipcode) {
                    getSuburbs(response.data.zipcode)
                }
            })
            .catch(() => {
                setloading(false)
            })
    }
    React.useEffect(() => {
        getData()
    }, []);

    React.useEffect(() => {
        console.log('fileList', fileList)
        if (!customBilling) {
            setFileList({});
        }
    }, [customBilling])

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const getSuburbs = zipcode => {
        setloading(true)
        API.get('/api/suburbs/zipcode/' + zipcode)
            .then(response => {
                setloading(false)
                if (response.data && response.data.data) {
                    setSuburbs(response.data.data)
                }
            })
            .catch(error => {
                setloading(false)
                console.error(error)
            })
    }

    const handleSubmit = async e => {
        setloading(true)
        e.preventDefault()
        try {
            const body = { ...data };
            // remove cer and stamp paths to search billing data locally
            if (!customBilling) {
                body.billing_tax_regime = '';
                body.billing_passphrase = '';
                body.billing_passphrase_test = '';
                body.billing_cer_path = ''
                body.billing_cer_path_test = ''
                body.billing_stamp_path = ''
                body.billing_stamp_path_test = ''
            }

            const response = await API.patch(`/api/subsidiaries/${match.params.id}`, body);

            if (response) {
                if (customBilling) {
                    await handleSaveFiles(response.data.id);
                }
                setloading(false)
                notification.success({
                    message: 'La sucursal se ha guardado exitosamente',
                })
            }
        } catch (error) {
            setloading(false)
            notification.error({ message: error.message })
        }
    }
    const handleBeforeUpload = (name, file) => {
        if (file) {
            const fileSizeLimit = 1 * 1024 * 1024 // 1 MB en bytes
            if (file.size > fileSizeLimit) {
                message.error('El archivo es demasiado grande. El tamaño máximo permitido es de 1 MB.')
                return false
            }
            const fileName = file.name
            const isFileTypeAccepted = acceptedFileTypes.includes(fileName.split('.').pop()) //includes(file.type);
            if (!isFileTypeAccepted) {
                message.error(`Solo es posible cargar documentos en formato ${acceptedFileTypes.join(', ')}.`)
                return false
            } else {
                setFileList(prevFileList => ({
                    ...prevFileList,
                    [name]: [file],
                }))
                // handleChange(name, file);
            }
        }
        return false
    }
    const handleFileChange = (name, info) => {
        const { status } = info.file
        console.log('status', info.file)
        if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`)
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`)
        }
    }
    const handleRemove = name => {
        const newFileList = { ...fileList };
        delete newFileList[name];
        setFileList(newFileList);
    }
    const handleSaveFiles = id => {
        const formData = new FormData();

        const {
            billing_cer_path, billing_stamp_path, billing_cer_path_test, billing_stamp_path_test,
        } = fileList;

        if (billing_cer_path && billing_cer_path[0] instanceof File) {
            formData.append('billing_cer_path', fileList.billing_cer_path[0]);
        }

        if (billing_stamp_path && billing_stamp_path[0] instanceof File) {
            formData.append('billing_stamp_path', billing_stamp_path[0]);
        }

        if (billing_cer_path_test && billing_cer_path_test[0] instanceof File) {
            formData.append('billing_cer_path_test', billing_cer_path_test[0]);
        }

        if (billing_stamp_path_test && billing_stamp_path_test[0] instanceof File) {
            formData.append('billing_stamp_path_test', billing_stamp_path_test[0]);
        }

        API.post(`/api/subsidiaries/files/${id}`, formData)
            .then(() => {
                notification.success({
                    message: 'Certificado y clave de facturacion guardada exitosamente.',
                })
            })
            .catch(error => {
                // notification.error({
                //     message: 'Ha ocurrido un error al guardar el certificado y clave de facturacion.',
                // })
                console.error(error.response)
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Editar sucursal</Divider>
            <Form style={{ maxWidth: '600px', margin: 'auto' }}>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Información general" key="1">
                        <p className="message">
                            Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben
                            ser llenados.
                        </p>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Nombre" className="required" hasFeedback>
                                    <Input
                                        placeholder="Nombre"
                                        value={data.name}
                                        onChange={e => {
                                            handleChange('name', e.target.value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Código" className="required" hasFeedback>
                                    <Input
                                        placeholder="Código"
                                        value={data.code}
                                        onChange={e => {
                                            handleChange('code', e.target.value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Nombre del negocio" className="required" hasFeedback>
                                    <Input
                                        placeholder="Nombre del negocio"
                                        value={data.business_name}
                                        onChange={e => {
                                            handleChange('business_name', e.target.value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Gerente" className="required">
                                    <Search
                                        value={currentSearchManager}
                                        placeholder="Gerente"
                                        onSearch={value =>
                                            `/api/users?filter[active]=1&filter[role_id]=2&filter[full_name]=${value}`
                                        }
                                        label="full_name"
                                        onChange={(key, value) => {
                                            setData({ ...data, manager_id: key })
                                            setCurrentSearchManager(value.full_name)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Teléfono" className="required" hasFeedback>
                                    <Input
                                        placeholder="Teléfono"
                                        onKeyPress={onKeyPressNumbers}
                                        value={data.phone}
                                        onChange={e => {
                                            if (e.target.value.length <= 10) {
                                                handleChange('phone', e.target.value)
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="RFC" className="required" hasFeedback>
                                    <Input
                                        placeholder="RFC"
                                        value={data.rfc}
                                        onChange={e => {
                                            handleChange('rfc', e.target.value.toLocaleUpperCase())
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Código postal" className="required" hasFeedback>
                                    <Input
                                        placeholder="Código postal"
                                        value={data.zipcode}
                                        onKeyPress={onKeyPressNumbers}
                                        onChange={e => {
                                            const value = e.target.value

                                            if (value.length <= 5) {
                                                handleChange('zipcode', value)
                                            }

                                            if (value.length >= 5) {
                                                getSuburbs(value)
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Dirección" className="required" hasFeedback>
                                    <Input
                                        placeholder="Dirección"
                                        value={data.address}
                                        onChange={e => {
                                            handleChange('address', e.target.value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={12}>
                                <Form.Item label="Colonia" className="required">
                                    <Select
                                        id="suburb_id"
                                        showSearch
                                        mode="default"
                                        style={{ width: '100%' }}
                                        value={data.suburb_id || undefined}
                                        placeholder="Colonia"
                                        optionFilterProp="children"
                                        notFoundContent={
                                            loading ? (
                                                <Spin style={{ margin: '0 auto' }} size="small" />
                                            ) : (
                                                'No hay resultados'
                                            )
                                        }
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        onChange={key => {
                                            handleChange('suburb_id', key)
                                        }}
                                    >
                                        {suburbs.map(d => (
                                            <Option key={d.id} value={d.id}>
                                                {d.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Usar logo de utilesa" hasFeedback>
                                    <Switch
                                        checked={!!data.logo_url}
                                        onChange={value => {
                                            handleChange('logo_url', value ? 'utilesa' : '')
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Visible en la web" hasFeedback>
                                    <Switch
                                        checked={!!data.visible}
                                        onChange={value => {
                                            handleChange('visible', value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col lg={12} md={12} sm={24}>
                                <Form.Item label="Activo" hasFeedback>
                                    <Switch
                                        checked={!!data.active}
                                        onChange={value => {
                                            handleChange('active', value)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </TabPane>
                    {billing_permission === 1 && (
                        <TabPane tab="Facturación" key="2">
                            <Row gutter={24}>
                                <Radio.Group
                                    style={{ marginLeft: 12 }}
                                    onChange={() => {
                                        setCustomBilling(!customBilling)
                                    }}
                                    value={customBilling}
                                >
                                    <Radio value={false}>Usar datos de titular</Radio>
                                    <Radio value={true}>Usar otros datos</Radio>
                                </Radio.Group>
                            </Row>
                            {customBilling && (
                                <div>
                                    <Row gutter={24}>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item label="Regimen fiscal" className="required" hasFeedback>
                                                <Search
                                                    id="tax_regime"
                                                    value={currentSearchTaxRegimes}
                                                    placeholder="Regimen fiscal"
                                                    onSearch={value => `/api/sat/tax_regimes`}
                                                    label="full_description"
                                                    keyName="code"
                                                    onChange={(key, value) => {
                                                        setCurrentSearchTaxRegimes(value.full_description)
                                                        handleChange('billing_tax_regime', value.code)
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item label="Razón social" className="required" hasFeedback>
                                                <Input
                                                    id="social_reason"
                                                    placeholder="Razón social"
                                                    value={data.social_reason}
                                                    onChange={e => {
                                                        handleChange('social_reason', e.target.value.toUpperCase())
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={24}>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item label="Tipo de contribuyente" hasFeedback>
                                                <Select
                                                    id="accountable_type"
                                                    showSearch
                                                    mode="default"
                                                    // style={{ width: '100%' }}
                                                    value={data.accountable_type || undefined}
                                                    placeholder="Tipo de contribuyente"
                                                    optionFilterProp="children"
                                                    notFoundContent={
                                                        loading ? <Spin style={{ margin: '0 auto' }} size="small" /> : 'No hay resultados'
                                                    }
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                    onChange={key => handleChange('accountable_type', key)}
                                                >
                                                    <Option key="persona_fisica" value="persona_fisica">Persona física</Option>
                                                    <Option key="persona_moral" value="persona_moral">Persona moral</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item label="Permitir facturacion resico" hasFeedback>
                                                <Switch
                                                    checked={data.is_resico}
                                                    onChange={value => {
                                                        handleChange('is_resico', value)
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={24}>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item label="Certificado (.CER)" required hasFeedback>
                                                <Upload
                                                    accept=".cer"
                                                    beforeUpload={newFile =>
                                                        handleBeforeUpload('billing_cer_path', newFile)
                                                    }
                                                    fileList={fileList['billing_cer_path']}
                                                    onChange={info => handleFileChange('billing_cer_path', info)}
                                                    onRemove={() => handleRemove('billing_cer_path')}
                                                >
                                                    <Button icon="plus">Subir</Button>
                                                </Upload>
                                            </Form.Item>
                                        </Col>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item label="Clave privada (.PEM)" required hasFeedback>
                                                <Upload
                                                    accept=".pem"
                                                    beforeUpload={newFile =>
                                                        handleBeforeUpload('billing_stamp_path', newFile)
                                                    }
                                                    fileList={fileList['billing_stamp_path']}
                                                    onChange={info => handleFileChange('billing_stamp_path', info)}
                                                    onRemove={() => handleRemove('billing_stamp_path')}
                                                >
                                                    <Button icon="plus">Subir</Button>
                                                </Upload>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={24}>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item
                                                label="Contraseña clave privada"
                                                className="required"
                                                hasFeedback
                                            >
                                                <Input
                                                    placeholder="Contraseña clave privada"
                                                    value={data.billing_passphrase}
                                                    type="password"
                                                    onChange={e => {
                                                        handleChange('billing_passphrase', e.target.value)
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {/* <Col lg={12} md={12} sm={24}>
                                    <Form.Item label="Utilizar credenciales de produccion para facturacion" hasFeedback>
                                        <Switch
                                            checked={data.is_resico}
                                            onChange={value => {
                                                handleChange('is_resico', value)
                                            }}
                                        />
                                    </Form.Item>
                                </Col> */}
                                    </Row>
                                    <Divider>Credenciales de prueba</Divider>
                                    <Row gutter={24}>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item label="Certificado (Test) (.CER)" hasFeedback>
                                                <Upload
                                                    accept=".cer"
                                                    beforeUpload={newFile =>
                                                        handleBeforeUpload('billing_cer_path_test', newFile)
                                                    }
                                                    fileList={fileList['billing_cer_path_test']}
                                                    onChange={info => handleFileChange('billing_cer_path_test', info)}
                                                    onRemove={() => handleRemove('billing_cer_path_test')}
                                                >
                                                    <Button icon="plus">Subir</Button>
                                                </Upload>
                                            </Form.Item>
                                        </Col>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item label="Clave privada (Test) (.PEM)" hasFeedback>
                                                <Upload
                                                    accept=".pem"
                                                    beforeUpload={newFile =>
                                                        handleBeforeUpload('billing_stamp_path_test', newFile)
                                                    }
                                                    fileList={fileList.billing_stamp_path_test}
                                                    onChange={info => handleFileChange('billing_stamp_path_test', info)}
                                                    onRemove={() => handleRemove('billing_stamp_path_test')}
                                                >
                                                    <Button icon="plus">Subir</Button>
                                                </Upload>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={24}>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item label="Contraseña clave privada (Test)" hasFeedback>
                                                <Input
                                                    placeholder="Contraseña clave privada"
                                                    value={data.billing_passphrase_test}
                                                    type="password"
                                                    onChange={e => {
                                                        handleChange('billing_passphrase_test', e.target.value)
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col lg={12} md={12} sm={24}>
                                            <Form.Item
                                                label="Utilizar credenciales de sandbox para facturacion"
                                                hasFeedback
                                            >
                                                <Switch
                                                    checked={data.sandbox}
                                                    onChange={value => {
                                                        handleChange('sandbox', value)
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </TabPane>
                    )}
                </Tabs>
                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>
                    <Form.Item>
                        <Link to="/subsidiaries">
                            <Button icon="arrow-left">Regresar</Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" icon="save" disabled={isSaveDisabled()} onClick={handleSubmit}>
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>
            </Form>
        </Segment>
    )
}

export default SubsidiariesEditContainer
